import { SET_IDEMPOTENCY_KEY } from '../../actions/api/idempotencyKey.js';

const initialState = {
	idempotencyKey: {},
};

const idempotencyKeyReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_IDEMPOTENCY_KEY:
			return {
				...state,
				[action.hashKey]: action.dataObject,
			};
		default:
			return state;
	}
};

export default idempotencyKeyReducer;
